import { Routes } from "@angular/router";
import { authGuard } from "../guards/auth.guard";

export const routes: Routes = [
    { path: '', loadChildren: () => import('../modules/lobby/lobby.module').then(m => m.LobbyModule) },
    { path: 'auth', loadChildren: () => import('../modules/auth/auth.module').then(m => m.AuthModule) },
    {
        path: 'conversation',
        loadChildren: () => import('../modules/chat/chat.module').then(m => m.ChatModule),
        canActivate: [ authGuard ]
    },
];
